var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "bi-x-circle-fill close-btn b-icon bi",
    attrs: {
      "data-v-18b5dc6a": "",
      "viewBox": "0 0 16 16",
      "width": "1em",
      "height": "1em",
      "focusable": "false",
      "role": "img",
      "aria-label": "x circle fill",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "currentColor"
    }
  }, [_c('g', {
    attrs: {
      "data-v-18b5dc6a": ""
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
    }
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };